<template>
	<div v-if="!loading && shouldRender" class="quick-actions">
		<VDropdown :shown="isOpen" :distance="5" @auto-hide="hideDropdown">
			<SuiButton
				:variant="variant"
				class="quick-actions__button"
				@click="showDropdown()"
			>
				<SuiIcon :name="icon" />
				{{ title }}
			</SuiButton>
			<template #popper>
				<div class="quick-actions__dropdown">
					<slot />
				</div>
			</template>
		</VDropdown>
	</div>
</template>

<script setup lang="ts">
import { SuiButton, SuiIcon } from '@developers/scoro-ui';
import { ref } from 'vue';

defineProps<{
	title: string;
	icon: string;
	variant?: 'primary' | 'secondary';
	loading: boolean;
	shouldRender: boolean | undefined;
}>();

const isOpen = ref(false);

const hideDropdown = () => {
	isOpen.value = false;
};
const showDropdown = () => {
	isOpen.value = true;
};
</script>

<style scoped lang="scss">
.quick-actions {
	&__dropdown {
		display: flex;
		flex-direction: column;
		padding: 0.75rem 0;
	}

	&__button {
		display: flex;
		gap: 0.5rem;

		.sui-icon {
			margin: 0;
		}
	}
}
</style>
